import pageStateService from 'core/PageState.service';
import { withRouter } from 'core/withRouter';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageUtil from 'utils/Page.util';
import TripFeeUpdateV from './TripFee.update.v';
import { TripFeeDTO } from 'models/trip-fee';
import tripFeeService from 'services/trip-fee.service';

class Params {
    error: string = null;
    isLoaded: boolean = false;

    item: TripFeeDTO = new TripFeeDTO();
}

function TripFeeUpdate(props: any) {
    const navigate = useNavigate();
    const [params, setParams] = useState(new Params());
    const id = props?.params?.id;
    const isUpdate: boolean = id ? true : false;
    // 중복요청방지
    const [isSubmitting, setIsSubmitting] = useState(false);

    /* ***************************************************************************************** */
    /* ************************************* STATE ********************************************* */
    /* ***************************************************************************************** */
    //onMount
    useEffect(() => {
        getData();

        return () => { };
    }, []);

    /* ***************************************************************************************** */
    /* ************************************* BASIC ********************************************* */
    /* ***************************************************************************************** */
    async function getData() {
        if (id && isUpdate) {
            try {
                const res = await tripFeeService.get(id);
                console.log('res {getData}', res);

                const curParams = PageUtil.deepCopy(params) as Params;
                curParams.isLoaded = true;
                curParams.item = res;

                setParams(curParams);
            } catch (error) {
                setParams((prev) => ({
                    ...prev,
                    isLoaded: true,
                    error: error,
                }));

                PageUtil.handleApiError(error);
            }
        } else {
            const item = new TripFeeDTO();
            item.type = 'province'; // 기본값

            setParams((params) => ({
                ...params,
                isLoaded: true,
                item: item,
            }));
        }
    }

    async function submit() {
        if (isSubmitting) return;

        const dto = PageUtil.deepCopy(params.item) as TripFeeDTO;

        if (!dto.type) {
            alert('타입을 선택해 주세요.');
            return;
        }

        if (!dto.name || dto.name.trim() === '') {
            alert(`${dto.type === 'province' ? '도명' : '지역명'}을 입력해 주세요.`);
            return;
        }

        if (dto.type === 'province') {
            if (!dto.tripFee || dto.tripFee <= 0) {
                alert('출장비(고객 청구)를 올바르게 입력해 주세요.');
                return;
            }
            // city 타입의 필드는 제거
            dto.tripCost = undefined;
        } else if (dto.type === 'city') {
            if (!dto.tripCost || dto.tripCost <= 0) {
                alert('출장 비용(출장자 지불)을 올바르게 입력해 주세요.');
                return;
            }
            // province 타입의 필드는 제거
            dto.tripFee = undefined;
        }

        console.log('submit', params.item, dto, isUpdate);

        setIsSubmitting(true);

        try {
            await tripFeeService.save(dto);
            alert('완료되었습니다.');

            pageStateService.clearPageState();
            navigate('/trip-fee', { replace: true });
        } catch (error) {
            setParams((prev) => ({
                ...prev,
                error: error,
            }));

            PageUtil.handleApiError(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    async function remove() {
        if (isSubmitting) return;

        if (!confirm('삭제하시겠습니까?')) return;
        setIsSubmitting(true);

        try {
            await tripFeeService.remove(id);
            alert('완료되었습니다.');

            pageStateService.clearPageState();
            navigate('/trip-fee', { replace: true });
        } catch (error) {
            setParams((prev) => ({
                ...prev,
                error: error,
            }));

            PageUtil.handleApiError(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    /* ***************************************************************************************** */
    /* ************************************** VAC ********************************************** */
    /* ***************************************************************************************** */
    const args = {
        params: params,
        setParams: setParams,
        isUpdate: isUpdate,

        handleChange: PageUtil.handleChange,

        submit: submit,
        remove: remove,
    };

    return <TripFeeUpdateV {...args} />;
}

export default withRouter(TripFeeUpdate, [tripFeeService]);